import axios from "axios"
import ROOTURL from "./ROOTURL"

export const SendOtpAPI = (data) => axios.post(`${ROOTURL}/sendotp`, data)

export const VerifyOtpAPI = (data) => axios.post(`${ROOTURL}/verifyotp`, data)

export const SignupAPI = (data) => axios.post(`${ROOTURL}/users`, data)

export const CheckSignupOrLoginAPI = (phone) =>
  axios.get(`${ROOTURL}/users?_where=(phone,like,${phone})`)
